import React, { useMemo } from 'react'
import merge from 'lodash/merge'
import { ColumnProps } from './Column.types'
import { ThemeContext } from '../Themer/Themer'

const ColumnInternal: React.FC<ColumnProps> = ({
    className = '',
    themeContext,
    background,
    spacing,
    padding,
    children,
    style,
    xs = 12,
    sm = 12,
    md = 12,
    lg = 12,
    xl = 12,
    block = false,
    noPadding = false,
    noPaddingBottom = false,
    noPaddingTop = false,
    grow = false,
    flexRow = false,
    justifyEnd = false,
    justifyCenter = false,
    justifySpaceBetween = false,
    alignCenter = false,
    alignEnd = false,
    wrap = false,
    show = true,
}) => {
    if (show !== undefined && show === false) {
        return null
    }

    const screenSizeContext = themeContext?.theme?.screenSizeConfig?.screenSizeContext ?? 'lg'

    const column = useMemo(() => {
        if (screenSizeContext === 'xs') {
            return xs
        } else if (screenSizeContext === 'sm') {
            return sm
        } else if (screenSizeContext === 'md') {
            return md
        } else if (screenSizeContext === 'lg') {
            return lg
        }
        return xl
    }, [screenSizeContext])

    const columnCount = useMemo(() => {
        if (typeof column === 'number') {
            return column
        }
        return column.span || 12
    }, [column])

    // const getSize = (size) => {
    //   if (typeof size === 'number') {
    //     return size
    //   }
    //   return size.span || 12
    // }

    const width = useMemo(() => {
        const base = 100 / 12
        let size = columnCount

        if (size === undefined) {
            size = 12
        }

        return size * base
    }, [columnCount])

    // const width = useMemo(() => {
    //     const c = themeContext.screenSizeConfig.screenSizeContext
    //     const base = 100 / 12
    //     let size
    //
    //     if (c === 'sm') {
    //         size = sm
    //     } else if (c === 'md') {
    //         size = md
    //     } else if (c === 'lg') {
    //         size = lg
    //     } else if (c === 'xl') {
    //         size = xl
    //     }
    //
    //     if (size === undefined) {
    //         size = 12
    //     }
    //
    //     return size * base
    // }, [themeContext.screenSizeConfig.screenSizeContext])

    const _spacing = (spacing || themeContext?.theme?.spacing) ?? 8

    const _style: React.CSSProperties = {
        width: `${width}%`,
        padding: `${_spacing}px`,
        background: background,
    }

    if (alignCenter) {
        _style.alignItems = 'center'
    }

    if (alignEnd) {
        _style.alignItems = 'flex-end'
    }
    if (justifyEnd) {
        _style.justifyContent = 'flex-end'
    }
    if (justifyCenter) {
        _style.justifyContent = 'center'
    }
    if (justifySpaceBetween) {
        _style.justifyContent = 'space-between'
    }
    if (flexRow) {
        _style.flexDirection = 'row'
    }

    if (noPaddingBottom) {
        _style.paddingBottom = 0
    }
    if (noPaddingTop) {
        _style.paddingTop = 0
    }
    if (noPadding) {
        _style.padding = 0
    }
    if (block) {
        _style.display = 'block'
    }
    if (grow) {
        _style.flexGrow = 1
    }
    if (wrap) {
        _style.flexWrap = 'wrap'
    }

    const columnSpecificStyle = () => {
        // const config = getConfig()
        //
        // if (typeof config === 'object' && config.style) {
        //     return config.style
        // }
        return {}
    }

    if (width === 0) {
        return null
    }

    return (
        <div
            style={merge(_style, style, columnSpecificStyle())}
            data-testid='Column'
            className={`r-column-container ${className}`}
        >
            {children}
        </div>
    )
}

const Column: React.FC<ColumnProps> = (props) => {
    return (
        <ThemeContext.Consumer>
            {(themeContext) => <ColumnInternal themeContext={themeContext} {...props} />}
        </ThemeContext.Consumer>
    )
}

export default Column
